import { AxiosResponse } from 'axios';

import { VisitorIdsParams } from 'utils/commonTypes';
import { publicInstance, instance as axios } from '../../api/axios';
import { IVisitorWithTransportFromServer, Visitor } from './interfaces';

type AddFaceRequest = {
  url: string;
  id: number;
};

export class VisitorService {
  static prefix = '/Visitor';

  public static async getVisitors(fio?: string, number?: string) {
    const branchLocal = localStorage.getItem('branchId') || 'null';
    const branchId = JSON.parse(branchLocal)?.id;

    if (branchId) {
      try {
        let url = `${VisitorService.prefix}?branchId=${branchId}`;
        if (fio) {
          url += `&fio=${fio}`;
        }
        if (number) {
          url += `&number=${number}`;
        }
        const response: AxiosResponse<Visitor[]> = await axios.get(url);

        return response.data;
      } catch (error: any) {
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть філію');
    }
  }

  public static async getVisitorPhones(visitorId: number) {
    if (visitorId) {
      try {
        const url = `${VisitorService.prefix}/phones?visitorId=${visitorId}`;
        const response: AxiosResponse<Visitor[]> = await axios.get(url);

        return response.data;
      } catch (error: any) {
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть відвідувача');
    }
  }

  public static async getVisitorPhoneDelete(numberId: number) {
    if (numberId) {
      try {
        const url = `${VisitorService.prefix}/number?id=${numberId}`;
        const response: AxiosResponse<Visitor[]> = await axios.delete(url);

        return response.data;
      } catch (error: any) {
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть номер');
    }
  }

  public static async getVisitorPhoneLatest(numberId: number) {
    if (numberId) {
      try {
        const url = `${VisitorService.prefix}/number?id=${numberId}`;
        await axios.patch(url);
      } catch (error: any) {
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть номер');
    }
  }

  public static async postVisitor(visitor: any) {
    if (visitor) {
      try {
        const url = `${VisitorService.prefix}`;
        await axios.post(url, visitor);
      } catch (error: any) {
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть відвідувача');
    }
  }

  public static async getVisitorDelete(visitorId: number) {
    if (visitorId) {
      try {
        const url = `${VisitorService.prefix}?id=${visitorId}`;
        const response: AxiosResponse<Visitor[]> = await axios.delete(url);

        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data) {
          throw new Error(error.response.data);
        }
        throw new Error(error);
      }
    } else {
      throw new Error('Виберіть відвідувача');
    }
  }

  public static async getVisitorPhoneAdd(data: any) {
    try {
      const url = `${VisitorService.prefix}/number`;
      const response: AxiosResponse<Visitor[]> = await axios.post(url, data);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async getDriverByID(id: string) {
    try {
      const url = `/Driver/${id}`;
      const response: AxiosResponse<Visitor> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getFaceID(url: string) {
    try {
      const response: AxiosResponse = await publicInstance.get(`${url}&timeout=5`);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося отримати дані. Зверніться до реєстратора');
    }
  }

  public static async addFaceID({ url, id }: AddFaceRequest) {
    try {
      const response: AxiosResponse = await publicInstance.get(`${url}&user_id=${id}`);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getDriverByIDOrPhone(idData: VisitorIdsParams) {
    try {
      const url = `/Driver`;
      const branchLocal = localStorage.getItem('branchId') || 'null';
      const branchId = JSON.parse(branchLocal)?.id;

      if (idData.phoneNumber || idData.id) {
        const response: AxiosResponse<IVisitorWithTransportFromServer> = await axios.get(url, {
          params: { ...idData, branchId },
        });

        return response.data;
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося отримати дані. Зверніться до реєстратора');
    }
  }
}
